import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";

function* editConfiguration(action) {
    try {
        const { refreshData } = action.payload;
        const conf = {
            ...action.payload.conf,
            engine_version: 1,
            configuration: {
                ...action.payload.conf.configuration,
                extra: {
                    payment_code: 1,
                    flag_used_credit: false,
                    denomination_list: 1,
                    game_features_list: 1
                },
                cards: {
                    ...action.payload.conf.configuration.cards,
                    //sort: 1,
                    //lines: 1,
                    //number: 1,
                    //columns: 1,
                    //free_spot: 1
                },
                balls: {
                    ...action.payload.conf.configuration.balls,
                    //stop: 1,
                    //maximum: 1,
                    //extra_num: 1
                },
                game: {
                    ...action.payload.conf.configuration.game,
                    pick: 1,
                    engine_type: 1,
                    game_sub_type: 1
                },
                bet: {
                    ...action.payload.conf.configuration.bet,
                    max: 1,
                    limit_default: 1,
                    minimum_total: 1
                },
                default_coin: {
                    coin: action.payload.conf.configuration.default_coin && action.payload.conf.configuration.default_coin.coin && action.payload.conf.configuration.default_coin.coin.length > 0 ? Number(action.payload.conf.configuration.default_coin.coin.toString()) : null

                }
            }
        };

        yield call(() => gamesAPI.editConfiguration(conf));
        ToasterService.successToast("Configuration successfully edited");

        yield put({
            type: GamesActionTypes.EDIT_CONF_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_GAME_CONFIGURATIONS,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error saving Configuration.");

        yield put({
            type: GamesActionTypes.EDIT_CONF_FAIL,
            message: e.message
        });
    }
}

export function* editConfigurationWatcher() {
    yield takeLatest(GamesActionTypes.EDIT_CONF, editConfiguration);
}

function* createConfiguration(action) {
    try {
        const { refreshData } = action.payload;
        const conf = {
            ...action.payload.conf,
            engine_version: 1,
            configuration: {
                ...action.payload.conf.configuration,
                extra: {
                    payment_code: 1,
                    flag_used_credit: false,
                    denomination_list: 1,
                    game_features_list: 1
                },
                cards: {
                    ...action.payload.conf.configuration.cards,
                    //sort: 1,
                    //lines: 1,
                    //number: 1,
                    //columns: 1,
                    //free_spot: 1
                },
                balls: {
                    ...action.payload.conf.configuration.balls,
                    //stop: 1,
                    //maximum: 1,
                    //extra_num: 1
                },
                game: {
                    ...action.payload.conf.configuration.game,
                    pick: 1,
                    engine_type: 1,
                    game_sub_type: 1
                },
                bet: {
                    ...action.payload.conf.configuration.bet,
                    max: 1,
                    limit_default: 1,
                    minimum_total: 1
                },
                active_coins:{
                    coins: action.payload.conf.configuration.active_coins ? action.payload.conf.configuration.active_coins.coins : []
                },
                default_coin: {
                    coin: action.payload.conf.configuration.default_coin && action.payload.conf.configuration.default_coin.coin && action.payload.conf.configuration.default_coin.coin.length > 0 ? Number(action.payload.conf.configuration.default_coin.coin.toString()) : null

                }
            }
        };

        yield call(() => gamesAPI.createConfiguration(conf));
        ToasterService.successToast("Configuration successfully created");

        yield put({
            type: GamesActionTypes.CREATE_CONF_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_GAME_CONFIGURATIONS,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error saving Configuration.");

        yield put({
            type: GamesActionTypes.CREATE_CONF_FAIL,
            message: e.message
        });
    }
}

export function* createConfigurationWatcher() {
    yield takeLatest(GamesActionTypes.CREATE_CONF, createConfiguration);
}

function* deleteConfiguration(action) {
    try {
        const { id, refreshData } = action.payload;

        yield call(() => gamesAPI.deleteConfiguration(id));
        ToasterService.successToast("Configuration successfully deleted");

        yield put({
            type: GamesActionTypes.DELETE_CONF_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_GAME_CONFIGURATIONS,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error deleting Configuration.");

        yield put({
            type: GamesActionTypes.DELETE_CONF_FAIL,
            message: e.message
        });
    }
}

export function* deleteConfigurationWatcher() {
    yield takeLatest(GamesActionTypes.DELETE_CONF, deleteConfiguration);
}

function* activateConfiguration(action) {
    try {
        const { id, refreshData } = action.payload;

        yield call(() => gamesAPI.activateConfiguration(id));
        ToasterService.successToast("Configuration successfully activated");

        yield put({
            type: GamesActionTypes.ACTIVATE_CONF_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_GAME_CONFIGURATIONS,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error activating Configuration.");

        yield put({
            type: GamesActionTypes.ACTIVATE_CONF_FAIL,
            message: e.message
        });
    }
}

export function* activateConfigurationWatcher() {
    yield takeLatest(GamesActionTypes.ACTIVATE_CONF, activateConfiguration);
}

function* moveConfiguration(action) {
    try {
        const { conf, gameId, refreshData } = action.payload;

        let newConf = { ...conf };
        newConf.game_id = gameId;
        delete newConf.id;
        delete newConf.active;
        delete newConf.timestamp;
        delete newConf.game;
        // the API expands the category, the endpoint expects its id
        newConf.game_category_id = conf.game_category
            ? conf.game_category.id
            : null;
        delete newConf.game_category;
        newConf.configuration.label = newConf.label;
        newConf.configuration.subsidiary = newConf.subsidiary.id;
        newConf.subsidiary = newConf.subsidiary.id
        newConf.configuration.engine = 1;
        newConf.engine_version = 1;
        //delete newConf.engine_version;

        newConf = {
            ...newConf,
            configuration: {
                ...newConf.configuration,
                extra: {
                    payment_code: 1,
                    flag_used_credit: false,
                    denomination_list: 1,
                    game_features_list: 1
                },
                cards: {
                    ...action.payload.conf.configuration.cards,
                    //sort: 1,
                    //lines: 1,
                    //number: 1,
                    //columns: 1,
                    //free_spot: 1
                },
                balls: {
                    //stop: 1,
                    //maximum: 1,
                    //extra_num: 1,
                    ...newConf.configuration.balls
                },
                game: {
                    pick: 1,
                    engine_type: 1,
                    game_sub_type: 1,
                    ...newConf.configuration.game
                },
                bet: {
                    max: 1,
                    limit_default: 1,
                    minimum_total: 1,
                    ...action.payload.conf.configuration.bet
                },
                active_coins:{
                    coins: action.payload.conf.configuration.active_coins ? action.payload.conf.configuration.active_coins.coins : []
                },
                default_coin: {
                    coin: action.payload.conf.configuration.default_coin && action.payload.conf.configuration.default_coin.coin && action.payload.conf.configuration.default_coin.coin.length > 0 ? Number(action.payload.conf.configuration.default_coin.coin.toString()) : null

                }
            }
        };

        yield call(() => gamesAPI.createConfiguration(newConf));

        try {
            yield call(() => gamesAPI.deleteConfiguration(conf.id));
            ToasterService.successToast("Configuration successfully moved");

            yield put({
                type: GamesActionTypes.MOVE_GAME_CONF_SUCCESS
            });

            yield put({
                type: GamesActionTypes.GET_GAME_CONFIGURATIONS,
                payload: refreshData
            });
        } catch (error) {
            API.handleError(
                error.response,
                "Error remoting configuration from previous game"
            );

            yield put({
                type: GamesActionTypes.MOVE_GAME_CONF_FAIL,
                message: error.message
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error adding configuration to new game");

        yield put({
            type: GamesActionTypes.MOVE_GAME_CONF_FAIL,
            message: e.message
        });
    }
}

export function* moveConfigurationWatcher() {
    yield takeLatest(GamesActionTypes.MOVE_GAME_CONF, moveConfiguration);
}
